import React from 'react'
import { StateProvider } from '../state'
import PropTypes from 'prop-types'
import GroupContainerHeader from './GroupContainerHeader'
import GroupContainer from './GroupContainer'

const App = props => {
  const initialState = {
    nestedGroupData: props.nestedGroupData,
    groups: props.groups,
    acts: props.acts,
    nestedMyedGroups: props.nestedMyedGroups,
    myedGroups: props.myedGroups,
    myedActs: props.myedActs,
    courseTitle: props.courseTitle,
    coursenum: props.coursenum,
    applyGroupWeights: props.applyGroupWeights,
    loading: false,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'UPDATE_NESTED_GROUPS':
        return {
          ...state,
          nestedGroupData: action.payload,
        }
      case 'UPDATE_GROUPS':
        return {
          ...state,
          groups: action.payload,
        }
      case 'UPDATE_GROUP_ACT_ORDER':
        return {
          ...state,
          groups: state.groups.map(group => {
            if (group.id === action.groupId) {
              return {
                ...group,
                acts: action.acts,
              }
            }
            return group
          }),
        }
      case 'UPDATE_MAPPED_ACT':
        return {
          ...state,
          acts: state.acts.map(act => {
            if (act.id === action.actId) {
              return {
                ...act,
                mappedAct: action.mappedAct,
              }
            }
            return act
          }),
        }
      case 'UPDATE_GROUP_NAME':
        return {
          ...state,
          groups: state.groups.map(group => {
            if (group.id === action.groupId) {
              return {
                ...group,
                name: action.groupName,
              }
            }
            return group
          }),
        }
      case 'MAPPED_ASSESSMENT_CHANGE':
        return {
          ...state,
          myedGroups: action.myedGroups,
          acts: action.acts,
          myedActs: action.myedActs,
        }
      case 'UPDATE_GROUP_WEIGHT':
        return {
          ...state,
          groups: state.groups.map(group => {
            if (group.id === action.groupId) {
              return {
                ...group,
                group_weight: action.groupWeight,
              }
            }
            return group
          }),
        }
      case 'UPDATE_ACTS':
        return {
          ...state,
          acts: action.payload,
        }
      case 'UPDATE_MYED_ACTS':
        return {
          ...state,
          myedActs: action.payload,
        }
      case 'ENABLE_DISABLE_WEIGHTS':
        return {
          ...state,
          applyGroupWeights: action.payload,
        }
      case 'UPDATE_LOADING_STATUS':
        return {
          ...state,
          loading: action.loading,
        }
      default:
        return state
    }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <h1
        className="me-course-title"
        dangerouslySetInnerHTML={{ __html: props.courseTitle }}
      />
      <GroupContainerHeader />
      <GroupContainer />
    </StateProvider>
  )
}

export default App

App.propTypes = {
  nestedGroupData: PropTypes.array,
  groups: PropTypes.array,
  acts: PropTypes.array,
  nestedMyedGroups: PropTypes.array,
  myedGroups: PropTypes.array,
  myedActs: PropTypes.array,
  courseTitle: PropTypes.string,
  coursenum: PropTypes.string,
  applyGroupWeights: PropTypes.string,
}
